import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useConditionalFeature,
} from '@americanexpress/conditional-features';
import { RenderModule } from 'holocron';
import clsx from 'clsx';
import RoomsTravelersInfoModal from './RoomsTravelersInfoModal';
import { getRoomsTravelers } from '../../selectors/requestSelectors';
import { getBundleType, getHasRooms } from '../../selectors/filtersSelectors';
import { setRoomsTravelersAction } from '../../ducks/requestDuck';
import packageContext from '../../context/packageContext';
import BundleTypeDropdown from './BundleTypeDropdown/BundleTypeDropdown';
import FlightClassDropdown from './FlightClassDropdown/FlightClassDropdown';
import AirlineDropdown from './AirlineDropdown/AirlineDropdown';
import { hasDisableRoomsTravelerModalRule } from '../../constants/ruleConstants';
import themeContext from '../../context/themeContext';
import style from './FilterRow.scss';

const FilterRow = () => {
  const {
    config: {
      maxAdults,
      maxChildren,
      maxInfants,
      maxCombinedChildrenAndInfants,
      maxRooms,
    },
  } = React.useContext(packageContext);
  const theme = useContext(themeContext);

  const bundleType = useSelector(getBundleType);
  const roomsTravelers = useSelector(getRoomsTravelers);
  const hasRooms = useSelector(getHasRooms);
  const hasDisableRoomsTravelerModal = useConditionalFeature(hasDisableRoomsTravelerModalRule);

  const dispatch = useDispatch();
  const onChange = (roomsTravelersChange) => {
    dispatch(setRoomsTravelersAction(roomsTravelersChange));
  };
  return (
    <div className={clsx('row', style.rowHeight)} data-testid="filter-row">
      <BundleTypeDropdown />
      <div className={clsx('col-md-6 col-lg-3 col-xl-3 col-xs-12 flex')}>
        <RenderModule
          moduleName="axp-travel-search-rooms-travelers"
          props={{
            id: 'packages',
            version: 2,
            hasRooms,
            hasInfants: true,
            value: roomsTravelers,
            onChange,
            theme,
            maxAdults,
            maxChildren,
            maxInfants,
            maxCombinedChildrenAndInfants,
            maxRooms,
            lob: 'bundles',
          }}
        />
        {
          !hasDisableRoomsTravelerModal
          && <RoomsTravelersInfoModal bundleType={bundleType} />
        }
      </div>
      <FlightClassDropdown />
      <AirlineDropdown />
    </div>
  );
};

export default FilterRow;
